<template>
    <div>
        <div class="card-body text-center">
            <h4><i class="fas fas fa-hourglass-half"></i>&nbsp;Waiting for buyer to escrow funds.</h4>
        </div>
        <div class="card-body text-center">
            <p class="text-center aboutscroll">
                After the funds have been deposited in the escrow, you may begin shipping the merchandise.
            </p>
        </div>
    </div>
</template>


<script>
    export default {
        name: "Open"
    }
</script>

<style scoped>

</style>